import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=6cc1fcda&scoped=true&"
var script = {}
import style0 from "@/assets/css/login.css?vue&type=style&index=0&id=6cc1fcda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1fcda",
  null
  
)

export default component.exports